import { Col, Form, Row } from "antd";
import ModalCustom from "components/commons/ModalCustom";
import FormItem from "components/form/FormItem";
import useToggleModal from "hooks/useToogleModal";
import React, { useEffect, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import VNCitySelector from "../VNCitySelector";

const CustomInfoModal = ({ data, onFinish, loading = false }, ref) => {
   const [form] = Form.useForm();
   const { t } = useTranslation();
   const { visible, toggleModal } = useToggleModal();

   const onCancel = () => {
      toggleModal();
   };
   
   useImperativeHandle(
      ref,
      () => ({
         open: () => {
            toggleModal();
         }
      })
   );

   useEffect(() => {
      if (data) {
         form.setFieldsValue(data);
      } else {
         form.resetFields();
      }
   }, [data]);

   return (
      <ModalCustom
         open={visible}
         onCancel={onCancel}
         title={t('ordersReturn.pickupInformation')}
         width={700}
         onOk={() => form.submit()}
         centered
         confirmLoading={loading}
      >
         <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={[20, 20]}>
               <Col md={12}>
                  <FormItem
                     name="lastName" 
                     label={t('common.input.name.label')}
                  />
               </Col>
               <Col md={12}>
                  <FormItem
                     name="firstName"
                     label={t('common.input.surname.label')}
                  />
               </Col>
               <Col md={12}>
                  <FormItem
                     name="telephone"
                     label={t('common.input.phone.label')}
                  />
               </Col>
               <Col md={12}>
                  <FormItem
                     name="email"
                     label="Email"
                  />
               </Col>
               <VNCitySelector form={form} />
               <Col md={12}>
                  <FormItem
                     name="addressLine1"
                     label={t('common.input.address.label')}
                     required
                  />
               </Col>
               <Col md={12}>
                  <FormItem
                     name="addressLine2"
                     label={t('common.input.apartmentNumber.label')}
                     required
                  />
               </Col>
            </Row>
         </Form>
      </ModalCustom>
   )
}

export default React.forwardRef(CustomInfoModal);